import utility from './utility';

const retrieveAddress = (place) => {
  const address = {
    addressLine1: '',
    addressLine2: '',
    cityName: '',
    stateCode: '',
    zipCode: '',
  };
  if (place && place.formatted_address) {
    const addrParts = place.formatted_address.split(', ');
    if (addrParts && addrParts.length > 3) {
      const [line1, cityName, stateCode] = addrParts;
      address.addressLine1 = line1;
      address.cityName = cityName;
      if (stateCode) {
        const [state, zip] = stateCode.split(' ');
        address.stateCode = state;
        if (zip) {
          address.zipCode = zip;
        }
      }
    }
  }
  return address;
};
export default {
  name: 'googleAddressAutocomplete',
  mixins: [utility],
  methods: {
    initGoogleAutocomplete(inputElementId, placeChangedCallback) {
      // Configure google autocomplete
      window.google = undefined;
      const scriptEle = this.loadExternalScript(this.pd_envConfig.googleWidgetScript);

      scriptEle.onload = () => {
        document.getElementById(inputElementId).placeholder = '';
        // eslint-disable-next-line no-undef
        const gMap = new google.maps.places.Autocomplete(document.getElementById(inputElementId),
          { types: ['address'], componentRestrictions: { country: 'us' } });
        gMap.setFields(['formatted_address']);
        gMap.addListener('place_changed', () => {
          const place = gMap.getPlace();
          placeChangedCallback(retrieveAddress(place));
        });
        window.gm_authFailure = () => {
          const addressElement = document.getElementById(inputElementId);
          addressElement.placeholder = '';
          addressElement.removeAttribute('disabled');
          addressElement.style = '';
        };
      };
    },
  },
};
